var React = require('react');

function Cz (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-74 0h682.7v512H-74z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(69.4) scale(.94)","key":1},[React.createElement("path",{"fill":"#e80000","d":"M-74 0h768v512H-74z","key":0}),React.createElement("path",{"fill":"#fff","d":"M-74 0h768v256H-74z","key":1}),React.createElement("path",{"fill":"#00006f","d":"M-74 0l382.7 255.7L-74 511V0z","key":2})])]);
}

Cz.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cz;

Cz.default = Cz;
